<template>
    <div v-if="dados">
        <div class="text-center py-5" v-if="dados === true">
            <h2>Aguardando...</h2>
            <div class="small text-muted">{{ canal }}</div>
        </div>
        <template v-else-if="dados && dados.atendimento">
            <div class="form-row">
                <div class="col col-12 col-md-6">
                    <div class="text-center p-3 bg-dark text-white" v-if="dados.local">
                        <h3><strong>{{ dados.local }}</strong></h3>
                    </div>
                    <div class="text-center p-3" v-if="dados.atendimento && dados.atendimento.paciente">
                        <div class="lead">Paciente</div>
                        <h3><strong>{{ dados.atendimento.paciente.st_nome }}</strong></h3>
                    </div>
                    <div class="text-center p-3 bg-dark text-white" v-if="dados.atendimento && dados.atendimento.atendimento_procedimentos">
                        <div class="lead">Procedimento</div>
                        <h3 v-for="(atp, iax) in dados.atendimento.atendimento_procedimentos" :key="iax">
                            <strong v-if="atp.procedimento">{{ atp.procedimento.search }}</strong>
                        </h3>
                    </div>
                    <div v-for="(campo, icx) in dados.campos" :key="icx" class="text-center p-3" :class="icx % 2 == 0 ? '' : 'bg-dark text-white'">
                        <div class="lead">{{ campo.titulo }}</div>
                        <h3>
                            <strong style="white-space: pre-wrap;">{{ campo.valor }}</strong>
                        </h3>
                    </div>
                </div>
                <div class="col col-12 col-md-6 text-center">
                    <div v-if="arquivo_atual" style="height: 90vh;">
                        <div v-if="false">
                            <pre>{{ arquivo_atual }}</pre>
                        </div>
                        <div v-else-if="is_image(arquivo_atual)">
                            <img :src="arquivo_atual.temporary_url" class="img-fluid" style="max-height: 90vh;" />
                        </div>
                        <div v-else-if="arquivo_atual.st_tipo_arquivo == 'pdf'">
                            <embed :src="arquivo_atual.temporary_url" type="application/pdf" width="100%" height="600px" />
                        </div>
                        <div v-else>
                            <a :href="arquivo_atual.temporary_url" target="_blank">Abrir {{ arquivo_atual }}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-center alert alert-secondary py-1 small text-muted mb-0">
                #{{ dados.atendimento.id_atendimento }}
                - {{ dados.arquivos.length }} 
            </div>
        </template>
    </div>
</template>

<script>
// import _ from 'lodash';
import { subscribe, unSubscribe } from "../../../service/Notify.js";

export default {
    data() {
        return { 
            dados: null, 
            indice_arquivo: 0,
            fila: null, 
            id_unidade_operacao: null,
            local: null, 
            carosel: null, 
            canal_presenca: "", 
        };
    },

    computed: { 
        arquivo_atual() { 
            if ( this.dados && this.dados.arquivos && this.dados.arquivos.length > 0 ) { 
                return this.dados.arquivos[this.indice_arquivo];
            }
            return null;
        }, 

        canal: function () { 
            return 'painel-assist' 
                + '-' + ( this.fila ? this.fila : '0' ) 
                + '-' + ( this.id_unidade_operacao ? this.id_unidade_operacao : '0' ) 
                + '-' + this.slugify(this.local ? this.local : 'Local não definido');
        }
    },

    methods: { 
        slugify(str) {
            return str
                .normalize('NFD')                 // separa acentos das letras
                .replace(/[\u0300-\u036f]/g, '')  // remove acentos
                .toLowerCase()                    // tudo minúsculo
                .trim()                           // tira espaços nas pontas
                .replace(/[^a-z0-9\s-]/g, '')     // remove caracteres especiais
                .replace(/\s+/g, '-')             // troca espaços por hífen
                .replace(/-+/g, '-');             // remove hífens duplicados
        },

        is_image (arquivo) { 
            return arquivo.st_tipo_arquivo == 'png' || arquivo.st_tipo_arquivo == 'jpg' || arquivo.st_tipo_arquivo == 'jpeg';
        },

        is_office (arquivo) { 
            return arquivo.st_tipo_arquivo == 'docx' || arquivo.st_tipo_arquivo == 'xlsx' || arquivo.st_tipo_arquivo == 'pptx';
        },

        abrir (id_fila_laudo, id_unidade_operacao, local) { 
            this.fila = id_fila_laudo;
            this.id_unidade_operacao = id_unidade_operacao;
            this.local = local;

            let dominio = this.$store.state.dominio;

            this.canal_presenca = 'painelassist.' + dominio + '.' + this.slugify(local);

            window.Echo.join(this.canal_presenca);
            
            subscribe(this.$store.state.dominio, this.canal, (retorno) => {
                console.log('subscribe retorno 1', retorno);

                this.$util.load(this, { 
                    service: 'enfermagem', 
                    func: 'painel_execucao', 
                    parms: { 
                        id: retorno.data.id_atendimento,
                        painel: retorno.data.painel,
                        fila: this.fila, 
                        id_unidade_operacao: this.id_unidade_operacao, 
                        local: this.local
                    },
                    loadTo: res => { 
                        this.dados = res; 
                        this.indice_arquivo = 0; 

                        if ( this.carosel ) { 
                            clearInterval(this.carosel);
                        }

                        this.carosel = null;

                        if ( this.dados && this.dados.arquivos && this.dados.arquivos.length > 1 ) { 
                            this.carosel = setInterval(() => { 
                                this.indice_arquivo++; 
                                if ( this.indice_arquivo >= this.dados.arquivos.length ) { 
                                    this.indice_arquivo = 0; 
                                }
                            }, 5000);
                        }
                    }
                }); 
            });

            this.dados = true; 
        },

        reset() { 
            if ( this.canal_presenca ) { 
                window.Echo.leave(this.canal_presenca);
                this.canal_presenca = ""; 
            }

            unSubscribe(this.$store.state.dominio, this.canal);
            this.dados = null;

            if ( this.carosel ) { 
                clearInterval(this.carosel);
            }
        }
    },

    beforeUnmount() { 
        console.log('Unmounting');
        this.reset(); 
    },

    beforeDestroy() { 
        console.log('Destroying');
        this.reset(); 
    },
}
</script>